import {useHistory, useLocation} from "react-router";

function useRedirect() {

    const {search} = useLocation();
    const history = useHistory();

    return params => history.push({...params, search})
}

export default useRedirect;
